const translations = {
    'tile.biome': 'biom: %s',
    'tile.controlled': 'Obszar kontrolowany.',
    'tile.controlledHint': 'Możesz tu budować z osad kontrolujących ten teren.',
    'tile.id': 'id: %s',
    'tile.foundFreePopulation': 'Dostępna wolna populacja: %d',
    'tile.foundRequirement': 'Wymaga %d wolnej populacji do założenia osady.',
    'tile.foundingInProgress': 'Wyprawa osadnicza w drodze.',
    'tile.hostiles': 'Wrogie siły',
    'tile.hostileFaction': 'Frakcja: %s',
    'tile.hostileCount': 'Oddziały: %d',
    'tile.enemyUnitLine': '%s: %d',
    'tile.enemiesTitle': 'Wrogowie',
    'tile.enemiesNone': 'Brak wrogich sił.',
    'tile.enemiesDevNote': 'Widoczne tylko w trybie dev.',
    'tile.uncontrolled': 'Poza kontrolą.',
    'tile.uncontrolledHint': 'Załóż osadę, aby rozszerzyć kontrolę.',
    'tile.unoccupied': 'Niezamieszkały region',
    'tile.occupied': 'Osada',
    'tile.settlementName': 'nazwa: %s',
    'tile.settlementPopulation': 'populacja: %d',
    'tile.settlementTier': 'poziom: %s',
    'tile.position': 'pozycja: { q:%d, r:%d, s:%d }',
    'tile.rawJson': 'Surowy JSON',
    'tile.resources': 'zasoby: %s',
    'tile.scout': 'Zwiad',
    'tile.scoutAction': 'Wyślij zwiad',
    'tile.scouts': 'Zwiadowcy',
    'tile.scoutsWaiting': 'Zwiadowcy czekają na rozkazy.',
    'tile.scoutsReturn': 'Wróć do osady',
    'tile.scoutPlan': 'Rozkazy zwiadu',
    'tile.scoutPlanHint': 'Ustaw to pole jako następny cel aktywnego zwiadu.',
    'tile.scoutPlanAction': 'Ustaw następny cel',
    'tile.summary': 'Podsumowanie',
    'tile.tabSummary': 'Podsumowanie',
    'tile.tabEnemies': 'Wrogowie',
    'tile.tabSettlement': 'Osada',
    'tile.tabRaw': 'JSON',
    'tile.title': 'Szczegóły pola',
    'tile.undiscovered': 'Nieznany region',
    'tile.undiscoveredHint': 'Wyślij zwiad, aby odkryć to miejsce.',
};

export default translations;
